
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import GroundStationService from "../../../../service/GroundStationService";
import { containsSpecialChars, getBandKey, getCharacterLimitMessage, getInvalidRangeErrorMessage, getSpecialCharacterMessage, onKeyDown, showToastMessage, validateInputRange, validateLatLongInputRange, validateNumberWithoutDecimal } from "../../../../utils/commonFunctions";
import { VALIDATION_RULES } from "../../../../utils/constants";
import ConfirmationDialog from "../../../CommonComponents/confirmation_dialog/ConfirmationDialog";

interface GroundStationFormprops {
  station_type?: string;
  configure_station?: any;
  provider_stations?: any;
  update_provider_details?: (provider_stations) => void;
  get_all_ground_stations?: () => Promise<void>;
  create_manual_gs?: (station) => void;
  close: () => void;
  data?: any;
  mode: string;
  set_loading?: (value: boolean) => void;
  provider_detail?: any
}

const GroundStationForm: FC<GroundStationFormprops> = ({ station_type, configure_station, provider_stations, update_provider_details, get_all_ground_stations, create_manual_gs, close, data, mode, set_loading, provider_detail }) => {
  const params = useParams()
  const { mission_id } = params
  const [error, setError] = React.useState(false);
  const [groundStationName, setGroundStationName] = useState("");
  const [groundStationDetails, setGroundStationDetails] = useState({
    antenaSize: '',
    polarization: '',
    provider: '',
    altitude: '0',
  });
  const [groundStationPosition, setGroundStationPosition] = useState<any>({
    country: '',
    location: '',
    latitude: '',
    longitude: '',
    freqbands: [],
  });
  const [antennaIds, setAntennaIds] = useState({ '0': '' });

  const scrollRef = useRef(null)

  const [bandsData, setBandsData] = useState({});
  const [isShowModal, setIsShowModal] = useState<any>(false);
  const [currentkeyEvent, setCurrentKeyEvent] = useState('');
  useEffect(() => {
    if (mode === 'Update' && data && Object.keys(data).length > 0) {
      setGroundStationName(data?.['groundStationName'])

      setGroundStationDetails({
        antenaSize: data?.['properties']?.['antenaSize'],
        polarization: data?.['properties']?.['polarization'] ? data?.['properties']?.['polarization'] : '',
        provider: data?.['properties']?.['provider'],
        altitude: data?.['properties']?.['altitude'] ? data?.['properties']?.['altitude'] : '0',
      })
      setGroundStationPosition({
        country: data?.['properties']?.['country'] ? data?.['properties']?.['country'].includes(',') ? data?.['properties']?.['country'].split(',')[1] : data?.['properties']?.['country'] : '',
        location: data?.['properties']?.['location'] ? data?.['properties']?.['location'] : '',
        latitude: data?.['properties']?.['latitude'],
        longitude: data?.['properties']?.['longitude'],
        freqbands: data?.['properties']?.['freqbands'],
      })
      if (data?.['antennaId']) {
        data?.['antennaId'].map((id, index) => {
          setAntennaIds((prev) => ({
            ...prev,
            [`${index}`]: id
          }))
        })
      }

      let frequency_data = {}
      data?.['properties']?.['freqbands'].map((band) => {
        frequency_data = {
          ...frequency_data,
          [band]: {
            [`${getBandKey(band, false)}_GT`]: data?.['properties']?.[`${getBandKey(band, false)}_GT`],
            [`${getBandKey(band, false)}_EIRP`]: data?.['properties']?.[`${getBandKey(band, false)}_EIRP`],
            rxFreq: {
              [`${getBandKey(band, true)}freq`]: {
                min: data?.['properties']['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'],
                max: data?.['properties']['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max']
              }
            },
            txFreq: {
              [`${getBandKey(band, true)}freq`]: {
                min: data?.['properties']['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'],
                max: data?.['properties']['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max'],
              }
            }
          },
        }

      })
      setBandsData(frequency_data)
    }
  }, [data, mode])

  useEffect(() => {
    if (mode === 'Create') {
      const IsAntarisGsiteProvider = provider_detail?.IsAntarisGsiteProvider === true
      if (IsAntarisGsiteProvider) {
        if (!groundStationPosition.freqbands.includes('Bypass SDR')) {
          setGroundStationPosition({
            ...groundStationPosition,
            freqbands: [...groundStationPosition.freqbands, 'Bypass SDR']
          })
        }
      } else {
        if (groundStationPosition.freqbands.includes('Bypass SDR')) {
          setGroundStationPosition({
            ...groundStationPosition,
            freqbands: groundStationPosition.freqbands.filter((item: any) => item !== 'Bypass SDR')
          })
        }
      }
    }
  }, [provider_detail?.IsAntarisGsiteProvider, mode])


  const validate_ground_station_data = () => {
    if (groundStationName === '' || groundStationPosition?.['country'] === '' || groundStationPosition?.['location'] === '' || groundStationPosition?.['latitude'] === '' ||
      groundStationPosition?.['longitude'] === '' || groundStationDetails?.['altitude'] === '' || groundStationPosition.freqbands?.length === 0) {
      const field_name = groundStationName === '' ? 'ground station name' : groundStationPosition?.['country'] === '' ? 'country' : groundStationPosition?.['location'] === '' ? 'location' : groundStationPosition?.['latitude'] === '' ? 'latitude' : groundStationPosition?.['longitude'] === '' ? 'longitude' : groundStationDetails?.['altitude'] === '' ? 'altitude' : 'freqbands'
      showToastMessage('error', field_name === 'freqbands' ? `Please select atleast one frequency` : `Please enter ${field_name}`)
      return true
    } else {
      return false
    }
  }

  const create_new_ground_station = () => {

    let rxFreq: any = {}
    let txFreq: any = {}
    let gt_eirp: any = {}
    let validation_success: any = false

    if (validate_ground_station_data()) {
      setError(true)
      return
    } else if (groundStationPosition.freqbands?.length > 0) {
      setError(false)
      groundStationPosition.freqbands.map((band: any, i) => {
        if (band === 'Bypass SDR') {
          if (!validation_success && groundStationPosition.freqbands?.length === i + 1) {
            validation_success = 'success'
          }
          return
        }
        const rs_freq_range = band === 'UHF' ? [VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN, VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX] : band === 'Ka-band' ? [VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN, VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX] : band === 'X-band' ? [VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN, VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX] : [VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN, VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX]
        const ts_freq_range = band === 'UHF' ? [VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN, VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX] : band === 'Ka-band' ? [VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN, VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX] : [VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN, VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX]
        const gt_range = [0, 1000]

        if (['S-band', 'Ka-band'].includes(band) && (bandsData[band]?.[`${getBandKey(band, false)}_GT`] || bandsData[band]?.[`${getBandKey(band, false)}_EIRP`])) {
          if (+bandsData[band]?.[`${getBandKey(band, false)}_GT`] >= gt_range[0] && +bandsData[band]?.[`${getBandKey(band, false)}_GT`] <= gt_range[1]) {
            gt_eirp = {
              ...gt_eirp,
              [`${getBandKey(band, false)}_GT`]: bandsData[band]?.[`${getBandKey(band, false)}_GT`],
              [`${getBandKey(band, false)}_EIRP`]: bandsData[band]?.[`${getBandKey(band, false)}_EIRP`]
            }
          } else {
            showToastMessage('error', `The Frequency range of the ${band} GT is from 0 to 1000`)
            setError(true)
            validation_success = 'error'
            return
          }
        }
        if (band === 'X-band') {
          if (bandsData[band]?.[`${getBandKey(band, false)}_GT`]) {
            if (+bandsData[band]?.[`${getBandKey(band, false)}_GT`] >= gt_range[0] && +bandsData[band]?.[`${getBandKey(band, false)}_GT`] <= gt_range[1]) {
              gt_eirp = {
                ...gt_eirp,
                [`${getBandKey(band, false)}_GT`]: bandsData[band]?.[`${getBandKey(band, false)}_GT`],
              }
            } else {
              showToastMessage('error', `The Frequency range of the ${band} GT is from 0 to 1000`)
              setError(true)
              validation_success = 'error'
              return
            }
          }
        }

        if (band === 'UHF') {
          if (bandsData[band]?.['U_EIRP']) {
            gt_eirp = {
              ...gt_eirp,
              'U_EIRP': bandsData[band]?.['U_EIRP']
            }
          }
        }
        if (bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] && bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max']) {
          if (+bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] <= +bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max']) {
            if ((+bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] >= rs_freq_range[0]) && (+bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] <= rs_freq_range[1])) {
              rxFreq = {
                ...rxFreq,
                [`${getBandKey(band, true)}freq`]: bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]
              }
            } else {
              showToastMessage('error', `The Frequency range of the ${band} Rx is from ${rs_freq_range[0]} MHz to ${rs_freq_range[1]} MHz`)
              setError(true)
              validation_success = 'error'
              return
            }
          } else {
            showToastMessage('error', `${band} minimum Rx Frequency can't be greater than maximum Rx Frequency`)
            setError(true)
            validation_success = 'error'
            return
          }
        } else {
          showToastMessage('error', `${band} ${!bandsData[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] ? 'min' : 'max'} Rx Frequency is Required`)
          setError(true)
          validation_success = 'error'
          return
        }
        if (band !== 'X-band' && bandsData[band]?.['txFreq']) {

          if (bandsData[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] || bandsData[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max']) {
            if (+bandsData[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] <= +bandsData[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max']) {
              if ((+bandsData[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] >= ts_freq_range[0]) && (+bandsData[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] <= ts_freq_range[1])) {
                txFreq = {
                  ...txFreq,
                  [`${getBandKey(band, true)}freq`]: bandsData[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]
                }
              } else {
                showToastMessage('error', `The Frequency range of the ${band} Tx is from ${ts_freq_range[0]} MHz to ${ts_freq_range[1]} MHz`)
                setError(true)
                validation_success = 'error'
                return
              }
            } else {
              showToastMessage('error', `${band} minimum Tx Frequency can't be greater than maximum Tx Frequency`)
              setError(true)
              validation_success = 'error'
              return
            }
          }
        }

        if (!validation_success && groundStationPosition.freqbands?.length === i + 1) {
          validation_success = 'success'
        }
      })
      const antenna_Ids = Object.keys(antennaIds).filter(key => antennaIds[key] !== '').map(key => antennaIds[key])
      if (antenna_Ids?.length === 0) {
        showToastMessage('error', 'Antenna Ids cannot be empty')
        setError(true)
        return
      }

      let station: any = {
        groundStationName: groundStationName.trimEnd(),
        missionId: mission_id,
        antennaId: antenna_Ids,
        properties: {
          ...groundStationDetails,
          ...groundStationPosition,
          location: `${groundStationPosition?.['location'].trimEnd()}`,
          country: `${groundStationPosition?.['country'].trimEnd()}`,
          polarization: (groundStationDetails?.['polarization'] && groundStationDetails?.['polarization'] !== '') ? `${groundStationDetails?.['polarization'].trimEnd()}` : '',
          rxFreq: rxFreq,
          txFreq: txFreq,
          ...gt_eirp
        },
        status: (data && data?.['properties']?.['provider'] && data?.['properties']?.['provider'] !== '') ? 'Configured' : 'Associate With Provider'
      }

      if (data && data?.['groundStationId']) {
        station.groundStationId = data?.['groundStationId'];
      }

      if (validation_success === 'success') {
        if (mode === 'Update') {
          update_ground_station(station)
        } else {
          create_ground_station(station)
        }
      }
    }
  }

  const update_ground_station = async (station) => {
    set_loading?.(true);
    try {
      const res = await GroundStationService.updateGroundStations([station]);
      if (res.data) {
        if (configure_station) {
          let filter_provider_stations = provider_stations && provider_stations?.filter(gs => gs?.['groundStationId'] !== station?.['groundStationId'])
          let all_provider_stations = [...filter_provider_stations, station]
          update_provider_details && update_provider_details(all_provider_stations)
        } else {
          if (get_all_ground_stations) await get_all_ground_stations();
          showToastMessage('success', 'Ground Station updated successfully')
        }
        set_loading?.(false);
        close()
      } else {
        set_loading?.(false);
      }
    } catch (err: any) {
      console.error(err);
      set_loading?.(false);
    }
  }

  const create_ground_station = async (station) => {
    if (station_type && station_type === 'Manual') {
      create_manual_gs && create_manual_gs(station)
    } else {
      set_loading?.(true);
      try {
        const res = await GroundStationService.createGroundStation(station?.['groundStationName'], station);
        if (res) {
          showToastMessage('success', 'Ground Station created successfully')
          set_loading?.(false);
          close()
        } else {
          set_loading?.(false);
        }
      } catch (err: any) {
        console.error(err);
        set_loading?.(false);
      }
    }
  }

  const scroll_to_bottom = () => {
    const container = scrollRef.current;
    if (container) {
      (container as HTMLElement).scrollTop = (container as HTMLElement).scrollHeight;
      (container as HTMLElement).scrollIntoView({ behavior: 'smooth' });
    }
  }


  const getMinRXFrequency = useCallback((band: string) => {
    const bandKey = getBandKey(band, true)
    const min = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN
    const max = (bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] &&
      (band === 'UHF' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN) ||
      (band === 'S-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN) ||
      (band === 'Ka-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN) ||
      (+bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN)) ?
      +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max']
      : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX
    const input_length = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.INPUT_LENGTH : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.INPUT_LENGTH : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.INPUT_LENGTH : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.INPUT_LENGTH
    const error = bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] === '' ? 'Please enter min rx frequency' :
      (+bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] > +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max']) ?
        'Min rx frequency must be less than max rx frequency' : `Min rx frequency range must be from ${band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN} to 
                      ${(bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] &&
          (band === 'UHF' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN) ||
          (band === 'S-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN) ||
          (band === 'Ka-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN) ||
          (+bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN)) ?
          +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max']
          : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX}`

    return {
      min,
      max,
      error,
      input_length
    }
  }, [bandsData])

  const getMaxRXFrequency = useCallback((band: string) => {
    const bandKey = getBandKey(band, true)
    const min = (bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] &&
      (band === 'UHF' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX) ||
      (band === 'S-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX) ||
      (band === 'Ka-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX) ||
      (+bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX)) ?
      +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min']
      : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN
    const max = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX
    const input_length = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.INPUT_LENGTH : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.INPUT_LENGTH : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.INPUT_LENGTH : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.INPUT_LENGTH
    const error = bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] === '' ? 'Please enter max rx frequency' :
      (+bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['max'] < +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min']) ?
        'Max rx frequency must be greater than min rx frequency' : `Max rx frequency range must be from ${(bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] &&
          (band === 'UHF' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX) ||
          (band === 'S-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX) ||
          (band === 'Ka-band' && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX) ||
          (+bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN && +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX)) ?
          +bandsData?.[band]?.['rxFreq']?.[`${bandKey}freq`]?.['min']
          : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MIN} to ${band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'S-band' ? VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_X_BAND_FREQ.MAX}`

    return {
      min,
      max,
      error,
      input_length
    }
  }, [bandsData])

  const getMinTxFrequency = useCallback((band: string) => {
    const bandKey = getBandKey(band, true)
    const min = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN
    const max = (bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] &&
      (band === 'UHF' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN) ||
      (band === 'Ka-band' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN) ||
      (+bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN)) ?
      +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX
    const input_length = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.INPUT_LENGTH : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.INPUT_LENGTH : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.INPUT_LENGTH
    const error = bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] === '' ? 'Please enter min tx frequency' :
      (+bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] > +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max']) ?
        'Min tx frequency must be less than max tx frequency' : `Min tx frequency range must be from ${band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN} to 
                      ${(bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] &&
          (band === 'UHF' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN) ||
          (band === 'Ka-band' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN) ||
          (+bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN)) ?
          +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX}`

    return {
      min,
      max,
      error,
      input_length
    }
  }, [bandsData])

  const getMaxTxFrequency = useCallback((band: string) => {
    const bandKey = getBandKey(band, true)
    const min = (bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] &&
      (band === 'UHF' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX) ||
      (band === 'Ka-band' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX) ||
      (+bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX)) ?
      +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN
    const max = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX
    const input_length = band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.INPUT_LENGTH : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.INPUT_LENGTH : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.INPUT_LENGTH
    const error = bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] === '' ? 'Please enter max tx frequency' :
      (+bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['max'] < +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min']) ?
        'Max tx frequency must be greater than min tx frequency' : `Max tx frequency range must be from ${(bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] &&
          (band === 'UHF' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX) ||
          (band === 'Ka-band' && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX) ||
          (+bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] >= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN && +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] <= VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX)) ?
          +bandsData?.[band]?.['txFreq']?.[`${bandKey}freq`]?.['min'] : band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MIN : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MIN : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MIN} to ${band === 'UHF' ? VALIDATION_RULES.GROUND_STATION_UHF_FREQ.MAX : band === 'Ka-band' ? VALIDATION_RULES.GROUND_STATION_KA_BAND_FREQ.MAX : VALIDATION_RULES.GROUND_STATION_S_BAND_FREQ.MAX}`

    return {
      min,
      max,
      error,
      input_length
    }
  }, [bandsData])

  const deleteAntenaId = (antennaId) => {
    const allAntennaIds = { ...antennaIds };
    delete allAntennaIds[`${antennaId}`];
    const updatedAntennaIds = { 0: '' };
    Object.keys(allAntennaIds).forEach((key, index) => {
      updatedAntennaIds[index] = allAntennaIds[key];
    });
    setAntennaIds(updatedAntennaIds);
  }


  return (
    <div className="popup-model z-2">

      <div className='model-lg gap-3 w-80 p-0'>
        <div className='w-100 d-flex justify-content-between align-items-center px-5 pt-5'>
          <span className='form-heade-text fs-18' > Ground Station</span>
          <i onClick={() => setIsShowModal(true)} className="fe fe-x-circle me-1 fs-25 cursor-pointer text-white"></i>
        </div>

        <div className="modal_devider" />

        <div className={`pop-scroll-sm pt-0 pb-3 px-5`} ref={scrollRef}>
          <Form validated={error} className="d-flex flex-column gap-4">
            <div className="d-flex flex-wrap gap-3 w-100 justify-content-between mb-3">
              <div className="d-flex gap-2 flex-column w-30">
                <span className="form-content-text">{"Ground Station Name * :"}</span>
                <Form.Control
                  className="w-100"
                  required
                  disabled={false}
                  type="text"
                  placeholder="Title"
                  value={groundStationName}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                    }
                    setCurrentKeyEvent(e.key);
                  }}
                  onChange={(event) => {
                    event.preventDefault();
                    let isNotValidName = containsSpecialChars(event.target.value)
                    if (isNotValidName) {
                      showToastMessage('error', getSpecialCharacterMessage())
                    } else if (event.target.value.length <= 26) {
                      setGroundStationName(event.target.value.trimStart())
                    } else if (event.target.value.length > 26) {
                      if (currentkeyEvent === 'Backspace') {
                        setGroundStationName(event.target.value.trimStart());
                        setCurrentKeyEvent('');
                      } else {
                        showToastMessage('error', getCharacterLimitMessage(26))
                      }
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter ground station name
                </Form.Control.Feedback>
              </div>

              <div className="d-flex flex-column gap-2 w-30">
                <span className="form-content-text">{"Country * :"}</span>
                <Form.Control
                  className="w-100"
                  required
                  type="text"
                  disabled={false}
                  placeholder="Enter Country"
                  value={groundStationPosition.country}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(event) => {
                    event.preventDefault();
                    let isNotValidName = containsSpecialChars(event.target.value)
                    if (isNotValidName) {
                      showToastMessage('error', getSpecialCharacterMessage())
                    } else if (event.target.value.length <= 26) {
                      setGroundStationPosition({
                        ...groundStationPosition,
                        country: event.target.value.trimStart()
                      })
                    } else if (event.target.value.length > 26) {
                      showToastMessage('error', getCharacterLimitMessage(26))
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter country
                </Form.Control.Feedback>
              </div>

              <div className="d-flex flex-column gap-2 w-30">
                <span className="form-content-text">{"Location * :"}</span>
                <Form.Control
                  className="w-100"
                  required
                  type="text"
                  disabled={false}
                  placeholder="Enter Location"
                  value={groundStationPosition.location}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(event) => {
                    event.preventDefault();
                    let isNotValidName = containsSpecialChars(event.target.value)
                    if (isNotValidName) {
                      showToastMessage('error', getSpecialCharacterMessage())
                    } else if (event.target.value.length <= 26) {
                      setGroundStationPosition({
                        ...groundStationPosition,
                        location: event.target.value.trimStart()
                      })
                    } else if (event.target.value.length > 26) {
                      showToastMessage('error', getCharacterLimitMessage(26))
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter location
                </Form.Control.Feedback>
              </div>
            </div>
            <span className="border-top w-100"></span>

            {/* ----------------Details Related Inputs--------------- */}


            <div className="d-flex flex-wrap gap-3 w-100 justify-content-between mb-3">
              <div className="d-flex flex-column gap-2 w-30 ">
                <span className="form-content-text">{"Latitude (degree) * :"}</span>
                <Form.Control
                  className="w-100"
                  min={VALIDATION_RULES.GROUND_STATION_LATITUDE.MIN}
                  max={VALIDATION_RULES.GROUND_STATION_LATITUDE.MAX}
                  required
                  type="number"
                  step='any'
                  disabled={false}
                  placeholder="In Degrees (°)"
                  value={groundStationPosition.latitude}
                  onKeyDown={(e) => {
                    if (['e', 'E', '+'].includes(e.key) || e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(event: any) => {
                    event.preventDefault();
                    let value = event.target.value
                    value = value.replace(/^-?0+(?=\d)/, ""); // Remove leading zeros but allow single "0"
                    const validation = validateLatLongInputRange('Latitude', value, VALIDATION_RULES.GROUND_STATION_LATITUDE.MIN, VALIDATION_RULES.GROUND_STATION_LATITUDE.MAX, VALIDATION_RULES.GROUND_STATION_LATITUDE.INPUT_LENGTH, VALIDATION_RULES.GROUND_STATION_LATITUDE.PARAMETER)
                    if (validation.success) {
                      setGroundStationPosition({
                        ...groundStationPosition,
                        latitude: value
                      })
                    } else {
                      showToastMessage('info', validation.error)
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {groundStationPosition.latitude === '' ? `Please enter latitude` : getInvalidRangeErrorMessage('Latitude', VALIDATION_RULES.GROUND_STATION_LATITUDE.MIN, VALIDATION_RULES.GROUND_STATION_LATITUDE.MAX, VALIDATION_RULES.GROUND_STATION_LATITUDE.PARAMETER)}
                </Form.Control.Feedback>
              </div>
              <div className="d-flex flex-column gap-2 w-30">
                <span className="form-content-text">{"Longitude (degree) * :"}</span>
                <Form.Control
                  className="w-100"
                  min={VALIDATION_RULES.GROUND_STATION_LONGITUDE.MIN}
                  max={VALIDATION_RULES.GROUND_STATION_LONGITUDE.MAX}
                  required
                  type="number"
                  step='any'
                  disabled={false}
                  placeholder="In Degrees (°)"
                  value={groundStationPosition.longitude}
                  onKeyDown={(e) => {
                    if (['e', 'E', '+'].includes(e.key) || e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(event: any) => {
                    event.preventDefault();
                    let value = event.target.value
                    value = value.replace(/^-?0+(?=\d)/, ""); //remove unwated leading zeros
                    const validation = validateLatLongInputRange('Longitude', value, VALIDATION_RULES.GROUND_STATION_LONGITUDE.MIN, VALIDATION_RULES.GROUND_STATION_LONGITUDE.MAX, VALIDATION_RULES.GROUND_STATION_LONGITUDE.INPUT_LENGTH, VALIDATION_RULES.GROUND_STATION_LONGITUDE.PARAMETER)
                    if (validation.success) {
                      setGroundStationPosition({
                        ...groundStationPosition,
                        longitude: value
                      })
                    } else {
                      showToastMessage('info', validation.error)
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {groundStationPosition.longitude === '' ? `Please enter longitude` : getInvalidRangeErrorMessage('Logitude', VALIDATION_RULES.GROUND_STATION_LONGITUDE.MIN, VALIDATION_RULES.GROUND_STATION_LONGITUDE.MAX, VALIDATION_RULES.GROUND_STATION_LONGITUDE.PARAMETER)}
                </Form.Control.Feedback>
              </div>

              <div className="d-flex flex-column gap-2 w-30">
                <span className="form-content-text">{"Altitude (m) * :"}</span>
                <Form.Control
                  className="w-100"
                  required
                  type="number"
                  step={'any'}
                  min={VALIDATION_RULES.GROUND_STATION_ALTITUDE.MIN}
                  max={VALIDATION_RULES.GROUND_STATION_ALTITUDE.MAX}
                  disabled={false}
                  placeholder="In mm"
                  value={groundStationDetails.altitude}
                  onKeyDown={onKeyDown}
                  onChange={(event: any) => {
                    event.preventDefault();
                    let value = event.target.value
                    value = value.replace(/^0+(?=\d)/, "");
                    const validation = validateInputRange('Altitude', value, VALIDATION_RULES.GROUND_STATION_ALTITUDE.MIN, VALIDATION_RULES.GROUND_STATION_ALTITUDE.MAX, VALIDATION_RULES.GROUND_STATION_ALTITUDE.INPUT_LENGTH, 'm')
                    if (validation.success) {
                      setGroundStationDetails({
                        ...groundStationDetails,
                        altitude: value
                      })
                    } else {
                      showToastMessage('info', validation.error)
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {groundStationDetails.altitude === '' ? `Please enter altitude` : getInvalidRangeErrorMessage('Altitude', VALIDATION_RULES.GROUND_STATION_ALTITUDE.MIN, VALIDATION_RULES.GROUND_STATION_ALTITUDE.MAX, 'm')}
                </Form.Control.Feedback>
              </div>
            </div>
            <span className="border-top w-100"></span>

            <div className="d-flex flex-column gap-3">
              <span className="form-content-text">{"Antenna Ids * :"}</span>
              <div className="d-flex flex-wrap gap-4 w-100 justify-content-start">
                {Object.keys(antennaIds).map((antennaId: any, index: any) => (
                  <div key={index} className="d-flex gap-2" style={{ width: '260px' }}>
                    <Form.Control
                      className="flex-1"
                      type="text"
                      required
                      disabled={false}
                      placeholder="Enter Antenna Id"
                      value={antennaIds[antennaId]}
                      onKeyDown={validateNumberWithoutDecimal}
                      onChange={(event: any) => {
                        event.preventDefault();
                        if (event.target.value.length <= 10) {
                          setAntennaIds({
                            ...antennaIds,
                            [`${index}`]: event.target.value
                          })
                        } else {
                          showToastMessage('info', 'Maximum 10 digits allowed')
                        }
                      }}
                    />
                    {index !== 0 && (
                      <button className="antenna__button"
                        onClick={(event) => {
                          event.preventDefault();
                          deleteAntenaId(antennaId)
                        }}
                      >
                        <i className="fe fe-x close"></i>
                      </button>
                    )}
                  </div>
                ))}
                {Object.keys(antennaIds).length < 4 &&
                  <button className="antenna__button"
                    onClick={(event) => {
                      event.preventDefault();
                      setAntennaIds({
                        ...antennaIds,
                        [Object.keys(antennaIds).length]: ''
                      })
                    }}
                  >
                    <i className="fe fe-plus add__new"></i>
                  </button>}
              </div>
            </div>

            <span className="border-top w-100"></span>

            {/* ----------------Position Related Inputs--------------- */}

            <div className="d-flex flex-wrap gap-2 w-100 justify-content-between">

              <div className="d-flex flex-column gap-2 w-30">
                <span className="form-content-text">{"Antenna Size (m) :"}</span>
                <Form.Control
                  className="w-100"
                  type="number"
                  step={'any'}
                  min={0}
                  disabled={false}
                  placeholder="Enter Antenna Size (m)"
                  value={groundStationDetails.antenaSize}
                  onKeyDown={validateNumberWithoutDecimal}
                  onChange={(event: any) => {
                    event.preventDefault();
                    let value = event.target.value;
                    if (String(value).includes('-')) return;
                    value = value.replace(/^0+(?=\d)/, ""); // Remove leading zeros (except if the value is "0")
                    if (value.length <= 8) {
                      setGroundStationDetails({
                        ...groundStationDetails,
                        antenaSize: value
                      })
                    } else {
                      showToastMessage('info', 'Maximum 8 digits allowed')
                    }
                  }}
                />
              </div>
              <div className="d-flex flex-column gap-2 w-30">
                <span className="form-content-text">{"Polarization :"}</span>
                <Form.Control
                  className="w-100"
                  type="text"
                  disabled={false}
                  placeholder="Enter Polarization"
                  value={groundStationDetails.polarization}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(event) => {
                    event.preventDefault();
                    let isNotValidName = containsSpecialChars(event.target.value)
                    if (isNotValidName) {
                      showToastMessage('error', getSpecialCharacterMessage())
                    } else if (event.target.value.length <= 26) {
                      setGroundStationDetails({
                        ...groundStationDetails,
                        polarization: event.target.value.trimStart()
                      })
                    } else {
                      showToastMessage('error', getCharacterLimitMessage(26))
                    }
                  }}
                />
              </div>

              <div className="d-flex flex-column gap-3 w-30">
                <span className="form-content-text">{"Frequency Bands * :"}</span>
                <div className="flex gap-1 align-items-center justify-content-start">
                  {["Bypass SDR", "S-band", "X-band", "Ka-band", "UHF"].map((band: any) => {
                    const IsAntarisGsiteProvider = provider_detail?.IsAntarisGsiteProvider === true;
                    const isBypassSDR = band === 'Bypass SDR';
                    const shouldShowBand = isBypassSDR ? IsAntarisGsiteProvider : true;
                    const isDisabled = isBypassSDR && IsAntarisGsiteProvider;

                    if (!shouldShowBand) return null;

                    return (
                      <button id={`${band}`} className={` align-items-center d-flex justify-content-center btn fs-10 ${groundStationPosition.freqbands.includes(band) ? "btn-primary" : "btn-outline-primary"}`} key={band}
                        disabled={isDisabled}
                        style={{ minWidth: '60px', padding: '0.4rem 0.3rem', width: 'fit-content' }}
                        onClick={(e) => {
                          e.preventDefault()
                          if (!isDisabled) {
                            scroll_to_bottom()
                            if (groundStationPosition.freqbands.includes(band)) {
                              setGroundStationPosition({
                                ...groundStationPosition,
                                freqbands: groundStationPosition.freqbands.filter((item) => item !== band)
                              })
                              if (bandsData[band]) {
                                delete bandsData[band];
                              }
                            } else {
                              setGroundStationPosition({
                                ...groundStationPosition,
                                freqbands: [...groundStationPosition.freqbands, band]
                              })
                            }
                          }
                        }}>
                        {band}
                      </button>
                    )
                  })}
                </div>
              </div>
            </div>

            {/* ----------------Frequency Related Inputs--------------- */}

            {groundStationPosition.freqbands.length > 0 && groundStationPosition.freqbands.filter(band => band !== 'Bypass SDR').map(band => {
              return (
                <div className={`d-flex flex-wrap gap-3 w-100 ${['X-band'].includes(band) ? 'justify-content-start' : 'justify-content-between'}`} key={band}>
                  <div className="d-flex gap-2 w-100 align-items-center justify-content-between pt-5">
                    <span className="border-top w-45"></span>
                    <span className="fs-18 color-atmos-secondary">{band}</span>
                    <span className="border-top w-45"></span>
                  </div>
                  <div className="d-flex flex-column gap-3 w-30">
                    {band !== 'UHF' && <div className="d-flex flex-column gap-2 w-100">
                      <span className="form-content-text">{band} GT (dB/K) </span>
                      <Form.Control
                        className="w-100"
                        disabled={false}
                        min={VALIDATION_RULES.GROUND_STATION_GT.MIN}
                        max={VALIDATION_RULES.GROUND_STATION_GT.MAX}
                        type="number"
                        step='any'
                        placeholder={"Enter " + band + ' GT'}
                        value={bandsData?.[band]?.[`${getBandKey(band, false)}_GT`] || ''}
                        onKeyDown={onKeyDown}
                        onChange={(event: any) => {
                          event.preventDefault();
                          let value = event.target.value;
                          value = value.replace(/^0+(?=\d)/, "");
                          const name = `${getBandKey(band, false)} Band GT`
                          const validation = validateInputRange(name, value, VALIDATION_RULES.GROUND_STATION_GT.MIN, VALIDATION_RULES.GROUND_STATION_GT.MAX, VALIDATION_RULES.GROUND_STATION_GT.INPUT_LENGTH, '')
                          if (validation.success) {
                            const data = {
                              ...bandsData,
                              [band]: {
                                ...bandsData?.[band],
                                [`${getBandKey(band, false)}_GT`]: value
                              }
                            }
                            setBandsData(data)
                          } else {
                            showToastMessage('info', validation.error)
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getInvalidRangeErrorMessage(`${band} GT`, 0, 1000, '')}
                      </Form.Control.Feedback>
                    </div>}
                    {!['X-band'].includes(band) && <div className="d-flex flex-column gap-2 w-100">
                      <span className="form-content-text">{band} {'EIRP'} (dBW)  :</span>
                      <Form.Control
                        className="w-100"
                        type="number"
                        step='any'
                        disabled={false}
                        placeholder={`Enter ${band} ${'EIRP'}`}
                        value={bandsData?.[band]?.[`${getBandKey(band, false)}_EIRP`] || ''}
                        onKeyDown={onKeyDown}
                        onChange={(event: any) => {
                          event.preventDefault();
                          const name = `${getBandKey(band, false)} Band EIRP`
                          let value = event.target.value;
                          value = value.replace(/^0+(?=\d)/, ""); // Remove leading zeros (except if the value is "0")
                          if (value.toString().length <= 8) {
                            const data = {
                              ...bandsData,
                              [band]: {
                                ...bandsData?.[band],
                                [`${getBandKey(band, false)}_EIRP`]: value
                              }
                            }
                            setBandsData(data)
                          } else {
                            showToastMessage('info', `${name} Maximum 8 digits allowed`)
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter {band} {'EIRP'}
                      </Form.Control.Feedback>
                    </div>}
                  </div>
                  <div className={`d-flex flex-column gap-3 w-30 ${['X-band'].includes(band) && 'ms-7'}`}>
                    <div className="d-flex flex-column gap-2 w-100">
                      <span className="form-content-text">{"Min Rx Frequency (MHz) * :"}</span>
                      <Form.Control
                        className="w-100"
                        min={getMinRXFrequency(band).min}
                        max={getMinRXFrequency(band).max}
                        required
                        type="number"
                        step='any'
                        disabled={false}
                        placeholder="Enter Min Rx Frequency"
                        value={bandsData?.[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] || ''}
                        onKeyDown={onKeyDown}
                        onChange={(event: any) => {
                          event.preventDefault();
                          const name = `${getBandKey(band, true)} Band Min Rx Frequency`;
                          let value = event.target.value;
                          value = value.replace(/^0+(?=\d)/, ""); // Remove leading zeros (except if the value is "0")
                          const validation = validateInputRange(name, value, getMinRXFrequency(band).min, getMinRXFrequency(band).max, getMinRXFrequency(band).input_length, '')

                          if (validation.error) {
                            showToastMessage('info', validation.error)
                          } else {
                            const data = {
                              ...bandsData,
                              [band]: {
                                ...bandsData?.[band],
                                rxFreq: {
                                  ...bandsData?.[band]?.['rxFreq'],
                                  [`${getBandKey(band, true)}freq`]: {
                                    ...bandsData?.[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`],
                                    min: value
                                  }
                                }
                              }
                            }

                            if (data[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] === '' && data[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] === '') {
                              delete data[band]['rxFreq'][`${getBandKey(band, true)}freq`]
                            }
                            setBandsData(data)
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getMinRXFrequency(band).error}
                      </Form.Control.Feedback>
                    </div>
                    <div className="d-flex flex-column gap-2 w-100">
                      <span className="form-content-text">{"Max Rx Frequency (MHz) *:"}</span>
                      <Form.Control
                        className="w-100"
                        min={getMaxRXFrequency(band).min}
                        max={getMaxRXFrequency(band).max}
                        required
                        type="number"
                        step='any'
                        disabled={false}
                        placeholder="Enter Max Rx Frequency"
                        value={bandsData?.[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] || ''}
                        onKeyDown={onKeyDown}
                        onChange={(event: any) => {
                          event.preventDefault();
                          const name = `${getBandKey(band, true)} Band Max Rx Frequency`;
                          let value = event.target.value;
                          value = value.replace(/^0+(?=\d)/, ""); // Remove leading zeros (except if the value is "0")
                          const validation = validateInputRange(name, value, getMaxRXFrequency(band).min, getMaxRXFrequency(band).max, getMaxRXFrequency(band).input_length, '')
                          if (validation.error) {
                            showToastMessage('info', validation.error)
                          } else {
                            const data = {
                              ...bandsData,
                              [band]: {
                                ...bandsData?.[band],
                                rxFreq: {
                                  ...bandsData?.[band]?.['rxFreq'],
                                  [`${getBandKey(band, true)}freq`]: {
                                    ...bandsData?.[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`],
                                    max: value
                                  }
                                }
                              }
                            }
                            if (data[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] === '' && data[band]?.['rxFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] === '') {
                              delete data[band]['rxFreq'][`${getBandKey(band, true)}freq`]
                            }
                            setBandsData(data)
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getMaxRXFrequency(band).error}
                      </Form.Control.Feedback>
                    </div>
                  </div>
                  {!['X-band'].includes(band) && <div className="d-flex flex-column gap-3 w-30">
                    <div className="d-flex flex-column gap-2 w-100">
                      <span className="form-content-text">{"Min Tx Frequency (MHz) :"}</span>
                      <Form.Control
                        className="w-100"
                        min={getMinTxFrequency(band).min}
                        max={getMinTxFrequency(band).max}
                        required={bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] ? true : false}
                        type="number"
                        step='any'
                        disabled={false}
                        placeholder="Enter Min Tx Frequency"
                        value={bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] || ''}
                        onKeyDown={onKeyDown}
                        onChange={(event: any) => {
                          event.preventDefault();
                          const name = `${getBandKey(band, true)} Band Min Tx Frequency`;
                          let value = event.target.value;
                          value = value.replace(/^0+(?=\d)/, ""); // Remove leading zeros (except if the value is "0")
                          const validation = validateInputRange(name, value, getMinTxFrequency(band).min, getMinTxFrequency(band).max, getMinTxFrequency(band).input_length, '')
                          if (validation.error) {
                            showToastMessage('info', validation.error)
                          } else {
                            const data = {
                              ...bandsData,
                              [band]: {
                                ...bandsData?.[band],
                                txFreq: {
                                  ...bandsData?.[band]?.['txFreq'],
                                  [`${getBandKey(band, true)}freq`]: {
                                    ...bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`],
                                    min: value
                                  }
                                }
                              }
                            }
                            if (bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] === '' && bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] === '') {
                              delete data[band]['txFreq'][`${getBandKey(band, true)}freq`]
                            }
                            setBandsData(data)
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getMinTxFrequency(band).error}
                      </Form.Control.Feedback>
                    </div>
                    <div className="d-flex flex-column gap-2 w-100">
                      <span className="form-content-text">{"Max Tx Frequency (MHz) :"}</span>
                      <Form.Control
                        className="w-100"
                        required={bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] ? true : false}
                        min={getMaxTxFrequency(band).min}
                        max={getMaxTxFrequency(band).max}
                        type="number"
                        step='any'
                        disabled={false}
                        placeholder="Enter Max Tx Trequency"
                        value={bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] || ''}
                        onKeyDown={onKeyDown}
                        onChange={(event: any) => {
                          event.preventDefault();
                          const name = `${getBandKey(band, true)} Band Max Tx Frequency`;
                          let value = event.target.value;
                          value = value.replace(/^0+(?=\d)/, ""); // Remove leading zeros (except if the value is "0")
                          const validation = validateInputRange(name, value, getMaxTxFrequency(band).min, getMaxTxFrequency(band).max, getMaxTxFrequency(band).input_length, '')
                          if (validation.error) {
                            showToastMessage('info', validation.error)
                          } else {
                            const data = {
                              ...bandsData,
                              [band]: {
                                ...bandsData?.[band],
                                txFreq: {
                                  ...bandsData?.[band]?.['txFreq'],
                                  [`${getBandKey(band, true)}freq`]: {
                                    ...bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`],
                                    max: value
                                  }
                                }
                              }
                            }
                            if (bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['max'] === '' && bandsData?.[band]?.['txFreq']?.[`${getBandKey(band, true)}freq`]?.['min'] === '') {
                              delete data[band]['txFreq'][`${getBandKey(band, true)}freq`]
                            }
                            setBandsData(data)
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {getMaxTxFrequency(band).error}
                      </Form.Control.Feedback>
                    </div>
                  </div>}
                </div>
              )
            })}

          </Form>
        </div>

        <div className="d-flex justify-content-start flex-column gap-3">
          <div className="modal_devider" />
          <div className="d-flex justify-content-between align-items-center px-5 pb-5">
            <button
              disabled={false}
              type="button"
              className="btn btn-outline-cancel pe-7 ps-7 fs-14"
              onClick={close}
            >
              Cancel
            </button>
            <button
              disabled={false}
              type="button"
              className="btn btn-primary pt-1 pb-1 pe-7 ps-7 fs-14 "
              onClick={() => {
                create_new_ground_station()
              }}
            >
              {data && data?.['groundStationId'] ? 'Update' : `Create`}
            </button>
          </div>
        </div>

        <ConfirmationDialog
          type='cancel'
          open={isShowModal ? true : false}
          title={`Discard Ground Station Configuration?`}
          description={`Discarding ground station configuration flow will take you back to the list of ground stations.`}
          onCancel={() => setIsShowModal(false)}
          onConfirm={() => {
            close()
            setIsShowModal(false);
          }}
          confirm_button_text={`Discard`}
        />
      </div >
    </div >
  );
};

export default GroundStationForm;
